import { gql } from '@apollo/client';

export const GET_ADDRESS_RESIDENTIAL_AREA_REPORT_DETAIL = gql`
  query GetAddressResidentialAreaDetail($id: Long!) {
      addressResidentialAreaReportDetail(id: $id) {
      id
      residentialAddress
      standardAddress
      residentialName
      cityName
      stateAbbreviation
      zipcode
      status
      residentialAddressHash
      createdAt
      updatedAt
      images {
        id
        residentialAreaId
        imageS3Key
        stopNumber
        imageDisplayUrl
      }
    }
  }
`;
export const QUERY_ADDRESS_RESIDENTIAL_AREA_DETAIL_BY_HASH = gql`
  query QueryAddressResidentialAreaDetailByHash($residentialAddressHash: String!) {
    queryAddressResidentialAreaDetail(residentialAddressHash: $residentialAddressHash) {
      id
      residentialAddress
      standardAddress
      residentialName
      cityName
      stateAbbreviation
      zipcode
      residentialAddressHash
      images {
        id
        residentialAreaId
        imageS3Key
        stopNumber
        imageDisplayUrl
      }
    }
  }
`;
export interface AddressResidentialAreaImageType {
  id: string;
  residentialAreaId: number;
  imageS3Key: string;
  stopNumber: number;
  imageDisplayUrl?: string | null;
}

export interface AddressResidentialAreaDetailType {
  id: string;
  residentialAddress: string;
  standardAddress: string;
  residentialName: string;
  cityName?: string | null;
  stateAbbreviation?: string | null;
  zipcode?: string | null;
  status?: string | null;
  residentialAddressHash?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  images: AddressResidentialAreaImageType[];
}

export interface GetAddressResidentialAreaDetailResponse {
    addressResidentialAreaReportDetail: AddressResidentialAreaDetailType | null;
    queryAddressResidentialAreaDetail: AddressResidentialAreaDetailType | null;
}
